import { render, staticRenderFns } from "./asdzhuxue.vue?vue&type=template&id=4703d2d1&"
import script from "./asdzhuxue.vue?vue&type=script&lang=js&"
export * from "./asdzhuxue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports